import { toast, ToastContainer } from 'react-toastify';
import Modal from 'react-modal'
import { useEffect, useState } from "react";
import loading from "../../assets/images/loading.gif"
import Layout from '../Layout';
import { customStyles, formatWithCommas } from 'helpers';
import { makeGetRequest, makePostRequest } from 'request';

const UserPermissionsManagement =  () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [rolesAndThreshold, setRolesAndThreshold] = useState<Record<string, any>>([])
    const [formData, setFormData] = useState<Record<string, any>>({})
    const getEstimatedCostLimit = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getEstimatedCostLimit",
            params: {}
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setRolesAndThreshold(res)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }

    const handleThresholdUpdate = () => {
        setIsSubmitting(true)
        var request: Record<string, any> = {
            what: "UpdateEstimatedCostLimit",
            data: {
                estimatedCostLimitId: formData.estimatedCostLimitId,
                cost: formData.cost,
            }
        };
        
        makePostRequest(request)
            .then((response: any) => {
                setIsSubmitting(false)
                toast.success(response.msg)
                getEstimatedCostLimit()
            })
            .catch((error:any) => 
                {toast.error(error.msg); setIsSubmitting(false)}
            );
    }

    const row = rolesAndThreshold?.map((data: any, index: number) => {
        return (
            <tr key={index}>
                <td>{index + 1}</td>
                <td>{data?.approvalLevel}</td>
                <td>
                    {!data?.isUpdate && <div>{formatWithCommas(data?.cost)}</div>}
                    {data?.isUpdate && <div className='d-flex' style={{width: "50%"}}>
                        <input 
                            id="freightCostInput" 
                            className='custom-input'
                            type="number"
                            disabled={isSubmitting}
                            style={{borderTopRightRadius: 0, borderBottomRightRadius: 0, margin: 0}} 
                            value={data?.cost}
                            onChange={(e) => {
                                setRolesAndThreshold(rolesAndThreshold.map((d: any) => d.id === data?.id ? {...d, cost: e.target.value} : d));
                                setFormData({...formData, estimatedCostLimitId: data?.id, cost: e.target.value});
                            }} />
                        <input
                            className='custom-input'
                            style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                            type="text" 
                            disabled 
                            value={formatWithCommas(data?.cost)} 
                            />
                        <button className='custom-button orange' disabled={isSubmitting}
                        onClick={() => handleThresholdUpdate()} 
                        style={{height: "30px"}}>{isSubmitting ? "Saving..." : "Save Change"}</button>
                    </div>}
                    
                </td>
                <td>
                    {/* onclick, check find data of id in RolesAndThreshold and set isUpdate to true */}
                    {!data?.isUpdate && <button onClick={() => setRolesAndThreshold(rolesAndThreshold.map((d: any) => d.id === data?.id ? {...d, isUpdate: true} : d)) } className="actions">
                        <span className="material-symbols-rounded">edit_note</span>
                        <span>Update</span>
                    </button>}

                    {data?.isUpdate && <button onClick={() => setRolesAndThreshold(rolesAndThreshold.map((d: any) => d.id === data?.id ? {...d, isUpdate: false} : d)) } className="actions blue">
                        <span className="material-symbols-rounded">close</span>
                        <span>Cancel</span>
                    </button>}

                </td>
            </tr>
        )
    })

    useEffect(() => {
        getEstimatedCostLimit();        // eslint-disable-next-line
    }, [])

    const page = "Freight Cost Settings"

    return (
        <Layout title={page}>
           <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner" style={{height: "100vh"}}>
                        <div style={{padding: "16px 12px", fontSize: "14px", fontWeight: "500", color: "#333"}}>
                            Threshold Settings
                        </div>
                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <th style={{width: "5%"}}>SN</th>
                                    <th style={{width: "35%"}}>Approval Level</th>
                                    <th style={{width: "30%"}}>Freight Cost</th>
                                    <th style={{width: "30%"}}>Action</th>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            rolesAndThreshold?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                    
                                </tbody>
                            </table> 
                        </div>                       
                    </div>                 
                </div>
            </div>
            <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                <div className="loader">
                    <img src={loading} alt="loading" />
                    <p>Loading data...</p>
                </div>
            </Modal>
            <ToastContainer /> 
        </Layout>
    )
}

export default UserPermissionsManagement